import { useContext } from 'react';
import { MatchSceneStatus, MatchSceneName } from './liveScoreConstants';
import transformLanguageResult from './transformLanguageResult';
import { HeaderContext } from '@contexts/HeaderContext';
import { goToSabaScoreSingleMatch } from '../../utils/gotoSabaScoreUtils';

const formatSoccerStatus = (HalfStatus, MatchTime, HomeTeam) => {
    const maxMinutes = HalfStatus === '1H' ? 45 : 90;
    if (!MatchTime) return HalfStatus;
    return (
        <>
            {HalfStatus}
            {MatchTime > maxMinutes ? (
                <>
                    {maxMinutes}
                    {'+ '}
                    {HomeTeam?.InjuryTime ? HomeTeam?.InjuryTime : ''}
                </>
            ) : MatchTime && (
                <>
                    {MatchTime}
                    &#39;
                </>
            )}
        </>
    );
};
const formatLocalDate = (ticks) => {
    if (!ticks) return '';
    const date = new Date(ticks * 1000);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${mm}/${dd}`;
};
const formatLocalTime = (ticks) => {
    if (!ticks) return '';
    const date = new Date(ticks * 1000);
    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');
    return `${hh}:${mm}`;
};
const formatBasketballStatus = (statusCode) => {
    let text = '';
    switch (statusCode) {
    case MatchSceneStatus.OneHalf: {
        text = 'Q1';
        break;
    }
    case MatchSceneStatus.OneHalfEnd: {
        text = 'End Q1';
        break;
    }
    case MatchSceneStatus.TwoHalf: {
        text = 'Q2';
        break;
    }
    case MatchSceneStatus.TwoHalfEnd: {
        text = 'End Q2';
        break;
    }
    case MatchSceneStatus.ThreeHalf: {
        text = 'Q3';
        break;
    }
    case MatchSceneStatus.ThreeHalfEnd: {
        text = 'End Q3';
        break;
    }
    case MatchSceneStatus.FourHalf: {
        text = 'Q4';
        break;
    }
    default: {
        text = MatchSceneName[statusCode];
    }
    }
    return text;
};
export const MatchScene = ({
    Status,
    MatchStatus,
    homeFullScore,
    awayFullScore,
    MatchTime,
    Schedule,
    ScheduleTicks,
    DateShareZh,
    selectedSport,
    MatchDate,
    StartTime,
    HomeTeam,
    AwayTeam,
    isResult,
}) => {
    if (selectedSport === 'Basketball') {
        return (
            {
                // Q1 ~ Q4
                [MatchStatus]: (
                    <>
                        <div className="text-score">
                            {homeFullScore}
                            {' '}
                            -
                            {' '}
                            {awayFullScore}
                        </div>
                        <div className="text-time">
                            {{
                                [MatchStatus]: (<>{formatBasketballStatus(MatchStatus)}</>),
                            }[MatchStatus]}
                        </div>
                    </>
                ),
                // Deadball
                [MatchSceneStatus.NotStarted]: (
                    <>
                        <span className="text">{Schedule.slice(5, 10).replace('-', '/')}</span>
                        <div className="text-time">{Schedule.slice(-8, -3)}</div>
                    </>
                ),
                [MatchSceneStatus.Ended]: (
                    <>
                        <span className="text">{DateShareZh}</span>
                        <div className="text-score">
                            {homeFullScore}
                            {' '}
                            -
                            {' '}
                            {awayFullScore}
                        </div>
                        <div className="text-time">Full Time</div>
                    </>
                ),
                [MatchSceneStatus.Delayed]: (
                    <div className="text-time">
                        {{
                            [MatchStatus]: (<>{formatBasketballStatus(MatchStatus)}</>),
                        }[MatchStatus]}
                    </div>
                ),
                [MatchSceneStatus.ToBeDetermined]: (
                    <>
                        {MatchSceneName[MatchStatus]
                            ? <div className="text-time">{MatchSceneName[MatchStatus]}</div>
                            : ''}
                    </>
                ),
            }[MatchStatus]
        );
    }
    if (selectedSport === 'Cricket') {
        return (
            {
                [MatchSceneStatus.CricketStatus.Other]: <div>Other</div>, // 4
                [MatchSceneStatus.CricketStatus.Completed]: ( // 2
                    <>
                        <span className="text">{MatchDate}</span>
                        <div className="text-time">Finished</div>
                    </>
                ),
                [MatchSceneStatus.CricketStatus.Scheduled]: ( // 1
                    <>
                        <span className="text">{MatchDate}</span>
                        <div className="text-time">{StartTime}</div>
                    </>
                ),
                [MatchSceneStatus.CricketStatus.Live]: <span className="text-live">Live</span>, // 3
            }[Status]
        );
    }
    // Soccer
    return (
        {
            // Live, delay
            [Status]: (
                <>
                    <div className="text-score">
                        {homeFullScore}
                        {' '}
                        -
                        {' '}
                        {awayFullScore}
                    </div>
                    <div className="text-time">
                        {{
                            [Status]: (
                                <>
                                    {MatchSceneName[Status]
                                        ? <div className="text-time">{MatchSceneName[Status]}</div>
                                        : ''}
                                </>
                            ),
                            [MatchSceneStatus.FirstHalf]: formatSoccerStatus('1H', MatchTime, HomeTeam),
                            [MatchSceneStatus.Halftime]: 'HT',
                            [MatchSceneStatus.SecondHalf]: formatSoccerStatus('2H', MatchTime, HomeTeam),
                        }[Status]}
                    </div>
                </>
            ),

            // [Status]: (<div>{HomeTeam.InjuryTime} {AwayTeam.InjuryTime}</div>),
            // Deadball
            [MatchSceneStatus.NotStarted]: (
                <>
                    <span className="text">{formatLocalDate(ScheduleTicks)}</span>
                    <div className="text-time">{formatLocalTime(ScheduleTicks)}</div>
                </>
            ),
            [MatchSceneStatus.Ended]: (
                <>
                    {!isResult ? <span className="text">{DateShareZh}</span> : ''}
                    <div className="text-score">
                        {homeFullScore}
                        {' '}
                        -
                        {' '}
                        {awayFullScore}
                    </div>
                    <div className="text-time">Full Time</div>
                </>
            ),
        }[Status]
    );
};
export const LiveScoreCardResult = ({
    sportData,
    selectedSport,
    isResult,
}) => {
    const { languageContext } = transformLanguageResult(sportData);
    const [state] = useContext(HeaderContext);

    return (
        <div
            className="ls-match"
            onClick={() => goToSabaScoreSingleMatch(
                selectedSport,
                sportData.MatchId,
                state.language,
            )}
        >
            <div className="ls-match__header">
                <span className="text">
                    { languageContext?.League }
                </span>
            </div>
            <div className="ls-match__main">
                <div className="ls-match__team-home">
                    <span className="text">
                        { languageContext?.HomeTeam }
                    </span>
                    <div className="team-logo">
                        {
                            sportData.HomeTeam.Icon && (
                                <img
                                    src={sportData.HomeTeam.Icon}
                                    alt="icon"
                                />
                            )

                        }
                    </div>
                    {{
                        Cricket: (
                            <>
                                {{
                                    [MatchSceneStatus.CricketStatus.Completed]: (
                                        <span className="text-score">
                                            {sportData.HomeTeam?.Scores}
                                            (
                                            {sportData.HomeTeam.Overs}
                                            ov)
                                        </span>
                                    ),
                                }[sportData.Status]}
                            </>
                        ),
                    }[selectedSport]}
                </div>
                <div className="ls-match__info">
                    <MatchScene
                        Status={sportData.Status}
                        MatchStatus={sportData.MatchStatus}
                        HomeTeam={sportData.HomeTeam}
                        AwayTeam={sportData.AwayTeam}
                        homeFullScore={sportData.HomeTeam?.FullScore}
                        awayFullScore={sportData.AwayTeam?.FullScore}
                        MatchTime={sportData.MatchTime}
                        Schedule={sportData.Schedule}
                        ScheduleTicks={sportData.ScheduleTicks}
                        DateShareZh={sportData.DateShareZh}
                        MatchDate={sportData.MatchDate}
                        StartTime={sportData.StartTime}
                        selectedSport={selectedSport}
                        isResult={isResult}
                    />
                </div>
                <div className="ls-match__team-away">
                    <div className="team-logo">
                        {
                            sportData.AwayTeam.Icon && (
                                <img
                                    src={sportData.AwayTeam.Icon}
                                    alt="icon"
                                />
                            )
                        }
                    </div>
                    <span className="text">
                        {
                            languageContext?.AwayTeam
                        }
                    </span>
                    {{
                        Cricket: (
                            <>
                                {
                                    (sportData.AwayTeam.Scores !== null) ? (
                                        <span className="text-score">
                                            {sportData.AwayTeam?.Scores}
                                            (
                                            {sportData.AwayTeam?.Overs}
                                            ov)
                                        </span>
                                    ) : ''
                                }
                            </>
                        ),
                    }[selectedSport]}
                </div>
            </div>
        </div>
    );
};
